export const PARENT_ROW_KEY = '$$parent_row_key'
export const ROW_KEY = '$$row_key'
export const PAGE_INDEX = '$$page_index'

export const DATA_PRIMARY_KEY = 'id'
export const IGNORE_UNCHANGED_TABLE_ROW = 'IGNORE_UNCHANGED_TABLE_ROW'
export const MATCH_BY_INDEX = 'MATCH_BY_INDEX'
export const APPEND = 'APPEND'
export const DATA_STS_KEY = '_status'

export const DATA_STS_UPDATE = 'Update'
export const DATA_STS_DELETE = 'Delete'
export const DATA_STS_INSERT = 'Insert'
export const DATA_STS_UNCHANGED = 'Unchanged'